<template>
    <div class="o-t-transport-types">
        <div class="o-t-transport-types__name-wrapper">
            <div class="o-t-transport-types__icon">
                <img
                    alt="alt"
                    :src="activeTransportType.files.icon"
                >
            </div>
            <div class="o-t-transport-types__name">
                {{$t('ui.terminal.transport', 'Transport')}}
            </div>
        </div>
        <div class="o-t-transport-types__types-wrapper">
            <div
                :class="[
                    'o-t-transport-types__transport-type',
                    activeTransportType.id === type.id ? 'active' : ''
                ]"
                v-for="type in preparedTransports"
                :key="type.id"
                @click="changeTransportType(type)"
            >
                {{type.meta[`name_${getActiveLocale}`]}}
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'OTTransportTypes',
    data() {
        return {
            activeTransportType: null,
        }
    },
    computed: {
        ...mapGetters([
            'getActiveLocale',
            'getListChildren',
            'getOrderedServiceCategories',
            'getServicesObjects',
            'getServiceCategoriesAZ',
            'getListChildren'
        ]),
        getTransportServiceCategoryId() {
            return this.getOrderedServiceCategories.filter(service => {
                return service.meta.is_transport;
            })[0].id;
        },
        preparedTransports() {
            return this.getListChildren(this.getTransportServiceCategoryId);
        }
    },
    methods: {
        changeTransportType(item) {
            this.activeTransportType = item;
            this.$emit('changeTransportType', item);
        }
    },
    created() {
        this.changeTransportType(this.preparedTransports[0]);
    }
}
</script>

<style lang="scss" src="./theme.scss" />